<div class="workflow-card"
     [attr.data-tour]="'pathway-state-' + WorkflowState[workflowState]"
     [attr.data-workflow-id]="workflow?.workflowId"
     [class.workflow-disabled]="!(isActionable && hasWorkflowAccess)"
     [style.--category-colour]="categoryMetadata?.colour">
    <div class="d-flex flex-column card-content gap-2">
        <div class="card-header">
            <div class="d-flex me-auto align-items-center">
                @if (showOutcomeIcon) {
                    <adapt-display-workflow-category [showPlainTooltip]="showOutcomeIcon"
                                                     [category]="workflow?.category"></adapt-display-workflow-category>
                }
                <h3 #workflowLink
                    class="mb-0 ms-1">
                    <adapt-link-workflow [workflow]="workflow"
                                         [adaptLinkDisabled]="!workflow || workflow.private"
                                         class="me-auto"></adapt-link-workflow>
                </h3>
            </div>
            @if (connection && workflow?.isDismissible && canContinueWorkflow && hasWorkflowAccess) {
                <div class="ms-auto">
                    <button adaptButton="closeBorderless"
                            adaptTooltip="End pathway"
                            [attr.data-test]="'end-pathway-' + workflow?.workflowId"
                            class="workflow-dismiss"
                            (click)="deleteConnection(connection)"></button>
                </div>
            }
        </div>

        <div class="overview-component d-flex flex-column flex-grow-1 gap-2">
            <div class="card-body">
                @if (workflow && workflow.people) {
                    <div class="d-flex flex-row flex-wrap column-gap-3">
                        <!-- hidden for now -->
                        @if (workflow.time && false) {
                            <div class="text-nowrap"><i class="fas fa-fw fa-clock me-1"></i><b>Time required:</b> {{ workflow.time }}</div>
                        }
                        @if (workflow.people) {
                            <div class="text-nowrap"><i class="fas fa-fw fa-user-group me-1"></i><b>People required:</b>
                                {{ workflow.people }}
                            </div>
                        }
                    </div>
                }

                @if (workflow?.overview && !showStepOverviewComponent) {
                    <div class="mt-3"
                         [innerHtml]="workflow!.overview"></div>
                }
            </div>

            <ng-container #overviewContainer></ng-container>

            @if (workflow?.overview && !showStepOverviewComponent) {
                <adapt-workflow-card-action (workflowState)="workflowState = $event"
                                            [workflow]="workflow"
                                            [connection]="connection"> </adapt-workflow-card-action>
            }
        </div>
    </div>
</div>

@if (workflow?.category !== OrganisationCategoryValue.Others && (currentStatus === WorkflowStatusEnum.Current || currentStatus === WorkflowStatusEnum.Completed)) {
    <dx-tooltip [target]="workflowLink"
                class="dx-tooltip-element"
                [showEvent]="{ name: 'dxhoverstart', delay: 500 }"
                hideEvent="dxhoverend"
                position="top"
                [maxWidth]="550">
        <div *dxTemplate="let data of 'content'">
            <div class="adapt-tooltip-content text-start">
                <adapt-show-workflow-completion-status [workflow]="workflow"></adapt-show-workflow-completion-status>
            </div>
        </div>
    </dx-tooltip>
}
